import { useContext } from 'react';
import TextCtaType from '~/constants/TextCtaType';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import { CurrentWipStatus } from '~/contracts/vdp/Availability';
import useIsInExclusivePreview from './useIsInExclusivePreview';
import useIsWipVehicleReservedByUser from './useIsWipVehicleReservedByUser';

export default function useTextCtaButtonState() {
  const {
    vehicleAvailability: {
      isLoaded,
      data: {
        currentWipStatus: { status: wipStatus = CurrentWipStatus.Unknown } = {}
      }
    }
  } = useContext(UserVehicleContext);
  const isReservedByUser = useIsWipVehicleReservedByUser();
  const isInExclusivePreview = useIsInExclusivePreview();

  const isReservedByUserAndNotKicked =
    isReservedByUser && wipStatus !== CurrentWipStatus.Kicked;
  const cancelPreOrder = isReservedByUserAndNotKicked || isInExclusivePreview;

  return {
    type: cancelPreOrder ? TextCtaType.CancelPreOrder : TextCtaType.Default,
    isDisabled: !isLoaded,
    textAlignClass:
      isReservedByUser && isInExclusivePreview ? '!text-center' : '!text-left'
  };
}
